import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export class PdfExportService {
    static exportElement(element) {
        element.style.width = "1754px";
        element.style.height = "1240px";
        document.body.append(element);
        html2canvas(element, { useCORS: true, logging: false }).then(image => {
            document.body.removeChild(element);
            const doc = new jsPDF('landscape', '', 'a4', true);
            const docWidth = doc.internal.pageSize.getWidth();
            const docHeight = doc.internal.pageSize.getHeight();
            doc.addImage(image.toDataURL('image/png'), 'PNG', 0, 0, docWidth, docHeight, '', 'FAST');
            doc.save('canvas.pdf');
        })
    };
}


// WEBPACK FOOTER //
// ./src/services/PdfExportService.js